export default "__VITE_ASSET__Fw6$L3fa__"